module.exports = __webpack_public_path__ + "static/media/franchise02.1ccc92a2.png";